var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",style:({ display: _vm.showToast ? 'flex' : 'none' }),on:{"click":function($event){return _vm.$emit('update:show', false)}}},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }